// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__0z4Sb","title":"style_title__c_43_"};